



































import Vue from 'vue';
import moment from 'moment';
import { Component } from 'vue-property-decorator';
import DialogAddLogic from './components/DialogAddLogic.vue';
import DialogUpdateLogic from './components/DialogUpdateLogic.vue';
import { GeneralError } from '@feathersjs/errors';

@Component({
    filters: {
        formatDate: (value: string) => moment(value).format('LLL')
    },
    components: {
        DialogAddLogic,
        DialogUpdateLogic
    }
})
export default class LogicControl extends Vue {
    drawer = true;
    successMessage = false;
    error = {
        show: false,
        message: ''
    };
    query = {};
    pagination = {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: []
    };
    headers = [
        {
            text: 'ID',
            align: 'start',
            sortable: true,
            value: 'id',
        },
        {
            text: 'Alias',
            align: 'start',
            sortable: true,
            value: 'alias',
        },
        {
            text: 'Name',
            align: 'start',
            sortable: true,
            value: 'name',
        },
        {
            text: 'Date Added',
            align: 'end',
            sortable: true,
            value: 'createdAt'
        },
        {
            text: 'Actions',
            align: 'end',
            value: 'data-table-expand'
        }
    ];

    public get fetchQuery() {
        return Object.assign({}, {
            ...this.query,
            // ...this.extendedQuery,
            $populate: true
        }, {
            // ...this.searchQuery,
            $limit: this.pagination.itemsPerPage,
            $skip: (this.pagination.page-1) * this.pagination.itemsPerPage,
            ...this.sortingQuery
        });
    }

    public get dataQuery() {
        return {
            ...this.query,
            // ...this.extendedQuery,
            // ...this.searchDataQuery,
            $limit: this.pagination.itemsPerPage,
            $skip: (this.pagination.page-1) * this.pagination.itemsPerPage,
            ...this.sortingQuery
        };
    }

    public get sortingQuery() {
        if(this.pagination.sortBy.length !== 0) {
            const $sort: any = {};
            this.pagination.sortBy.map((item, index) => {
                switch(item) {
                    default:
                        $sort[item] = this.pagination.sortDesc[index] ? -1 : 1;
                }
                
            });
            return { $sort };
        }
        return null;
    }

    public onError(err: GeneralError) {
        this.error.show = true;
        if(err.errors && err.errors.length !== 0) {
            this.error.message = err.errors[0].message;
        } else {
            this.error.message = err.message;
        }
    }

}
